<template>
	<div class="mobileLgWrap_he">
        <van-nav-bar class="userNavBar" @click-left="onClickLeft" title="修改密码" left-arrow>
			<template #left>
				<van-icon name="../../../static/images/mobile/back.png" size="18" />
			</template>
		</van-nav-bar>
		
		<div class="loginMain_he">
			<van-form>
				<van-cell-group>
					<van-field
						v-model="password"
						clearable
						placeholder="请输入8-16位密码，字母+数字"
						:right-icon="rightIcon"
						:type="pwdType"
						@click-right-icon="changeType"
                        @input="changColor"
                        :rules="[{ pattern, message: '请输入8-16位字母和数字组合密码' }]"
					/>
					<!-- :error-message="errors.first('password')" -->
					<van-field
						v-model="repeatpassword"
						placeholder="请输入8-16位密码，字母+数字"
						clearable
						:right-icon="rightIconAgain"
						:type="pwdType"
						@click-right-icon="changeTypeAgain"
                        :rules="[{ pattern, message: '请输入8-16位字母和数字组合密码' }]"
					/>
					<div :class="phoneNum > 0 ? 'onLoginbtn' : ' mobileLoginBtn_he'" @click="findPassword()">
						<span><a href="javascript:;">确认</a></span>
					</div>
				</van-cell-group>
			</van-form>
		</div>
	</div>
</template>

<script>
import md5 from "js-md5";
import { Toast } from 'vant';
export default {
	data() {
		return {
			mobile: "",
			password: "",
			repeatpassword: "",
			yzm: "",
			seen: "",
			seenAgain: "",
			pwdType: "password", // 密码类型
			rightIcon: "closed-eye",
			rightIconAgain: "closed-eye",
			loadingFlg: false,
			loginDisable: false,
			type: "findPassword",
			// 计时器,注意需要进行销毁
			sendCodeBtnDisabled: false,
			sendCodeCaption: "获取验证码",
			refreshTimer: null,
            phoneNum: "",
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/,
		};
	},
	methods: {
        changColor(e) {
			this.phoneNum = e.length;
		},
		// 隐藏显示密码
		changeType() {
			this.pwdType = this.pwdType === "password" ? "text" : "password";
			this.seen = !this.seen; //小眼睛的变化
			if (this.seen) {
				this.rightIcon = "eye-o";
			} else {
				this.rightIcon = "closed-eye";
			}
		},
		// 再次隐藏显示密码
		changeTypeAgain() {
			this.pwdType = this.pwdType === "password" ? "text" : "password";
			this.seenAgain = !this.seenAgain; //小眼睛的变化
			if (this.seenAgain) {
				this.rightIconAgain = "eye-o";
			} else {
				this.rightIconAgain = "closed-eye";
			}
		},
		/**
		 * 忘记密码验证
		 */
		findPassword() {
			if (this.password == "") {
				Toast("请输入密码");
				return false;
			}
			if (this.repeatpassword == "") {
				Toast("请再次输入密码");
				return false;
			}
			if (this.password !== this.repeatpassword) {
				Toast("两次密码不一致");
				return false;
			}
			this.findPasswordFun(md5(this.password));
		},
		/**
		 * 忘记密码
		 */
		findPasswordFun(md5Password) {
			let param = {};
			param.password = md5Password;
			this.$axiosPackag.getMessageByAxios(
				"POST",
				"/user/updatePassword",
				param,
				null,
				null,
				(resD) => {
					if (resD) {
						Toast("密码修改成功");
						this.$router.push({ path: "/mobileLogin" });
					}
				},
				(errorCall) => {}
			);
		},
        onClickLeft() {
			this.$router.go(-1);
		},
	},
};
</script>
<style >
.userNavBar .van-nav-bar__title {
    font-weight: 600;
}
</style>
<style scoped>
.userNavBar {
	width: 100%;
	margin-top: 0.133333rem;
}
.mobileLgWrap_he{
    background: none;
}
.van-cell,
.van-cell-group {
	background: none;
}
.van-cell {
	background: none;
}
.van-icon-eye-o::before {
	color: #6d7174;
}
.van-cell::after {
	border: none;
}
.van-cell {
	border-bottom: 1px solid #DFDEDE;
	margin-bottom: .72rem;
}
[class*="van-hairline"]::after {
	border: none;
}
/* .van-icon-eye-o::before {
} */
.budgeMobileInput {
	width: 6.933333rem;
}
.senMsg {
	display: inline-block;
	padding: 5px 10px;
	margin: 5px 0;
	color: #ffffff;
	border-radius: 8px;
	font-size: 12px;
	position: absolute;
	right: 0.32rem;
	top: 0.08rem;
}
.bd_he {
	position: relative;
}
.budgeMobileDia {
	width: 5.093333rem;
}
.van-field {
	padding:.213333rem 0  .213333rem 0;
}
</style>


// WEBPACK FOOTER //
// MobileForgetPasswordNext.vue?48f92572